var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurnipGreens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#F8EEE1;}\n\t.st2{fill:#67348A;}\n\t.st3{fill:#74B757;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132,98.35c4.76,4.6,9.86,9.96,9.88,16.58c0.01,3.37-1.34,6.61-3.07,9.51c-5.13,8.61-13.85,15.01-23.6,17.32 c-0.86,0.2-1.74,0.38-2.53,0.77c-2.38,1.18-3.44,3.94-4.3,6.45l-0.82,1.44c-0.67-2.48-1.35-4.96-2.02-7.43 c-7.39-1.07-14.76-3.27-20.82-7.63s-10.65-11.13-11.19-18.57s3.59-15.33,10.53-18.08L132,98.35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140,108c-3.76,2.82-7.81,5.17-12.29,6.55c-6.12,1.88-12.67,1.88-19.1,1.72c-7.09-0.19-14.24-0.5-21.1-2.26 c-4.48-1.13-8.87-2.88-12.7-5.49c1.69-4.39,4.92-8.12,9.25-9.82l22.66-5.74L132,98.35C134.98,101.23,138.09,104.4,140,108z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.33,104.95c0,0,1.09,0.45,1.57-0.85c1.47-3.97,4.16-10.73,6.24-16.09c3.52,0.11,6.12-3.87,5.65-7.36 c-0.47-3.49-3.12-6.3-6.02-8.3c2.24-0.37,3.06-3.47,2.02-5.48c-1.05-2.02-3.21-3.15-5.25-4.16c1.6-3.27-1.41-7.74-5.04-7.49 s-6,5.09-3.98,8.11c-2.46-0.44-5.11,1.28-5.72,3.7c-0.6,2.43,0.94,5.19,3.32,5.95c-4.09-0.43-7.88,3.6-7.61,7.7 c0.27,4.1,4.11,7.5,8.22,7.72c0.67,5.38,2.8,11.78,4.73,15.46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.41,104.8c3.27-1.24,8.19-4.08,11.62-7.09c2.71,2.15,7.02,2.16,9.49-0.27s2.33-7.09-0.48-9.1 c1.92,0.85,4.44-0.02,5.41-1.89c0.98-1.86,0.27-4.43-1.53-5.52c2.96-0.77,4.18-5.14,2.03-7.33s-6.54-1.06-7.36,1.89 c-1.85-0.5-3.84-1-5.63-0.32c-1.79,0.68-3,3.09-1.8,4.58c-2.94-0.37-6.18-0.08-8.43,1.85c-2.25,1.93-2.84,5.89-0.56,7.79 c-1.69,4.54-3.78,10.29-5.07,13.61c-0.42,1.09,0.51,1.41,0.51,1.41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.46,101.67c-0.91-3.38-3.24-8.56-5.89-12.27c2.41-2.48,2.85-6.77,0.68-9.47c-2.17-2.69-6.82-3.03-9.1-0.43 c1.04-1.83,0.42-4.42-1.33-5.57c-1.76-1.16-4.38-0.71-5.65,0.97c-0.47-3.03-4.7-4.67-7.09-2.75s-1.7,6.4,1.15,7.51 c-0.68,1.79-1.38,3.72-0.88,5.57c0.5,1.85,2.78,3.3,4.37,2.25c-0.66,2.89-0.7,6.14,1,8.57c1.7,2.43,5.58,3.41,7.69,1.34 c4.35,2.14,9.86,4.79,13.04,6.41c1.04,0.53,1.46-0.37,1.46-0.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnipGreens);
export default __webpack_public_path__ + "static/media/Turnip_greens.0aeb17707be6e2a019d7969e2bffce52.svg";
export { ForwardRef as ReactComponent };